import buildVersion from "./buildVersion.json";

const RELOAD_KEY = "reloadedForVersion";

// Compares the bundle's build version with the deployed meta.json. If a newer
// build is live, clear caches and reload once so the user gets fresh files.
export const checkForNewVersion = async () => {
  if (process.env.NODE_ENV !== "production") return;
  try {
    const res = await fetch(`/meta.json?t=${Date.now()}`, { cache: "no-store" });
    const { version: latest } = await res.json();
    if (!latest || latest === buildVersion.version) return;
    if (sessionStorage.getItem(RELOAD_KEY) === latest) return;
    sessionStorage.setItem(RELOAD_KEY, latest);

    if (window.caches) {
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    }
    localStorage.clear();
    window.location.reload();
  } catch (err) {
    console.log(err);
  }
};
